




















































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import CoreButton from '@/components/CoreButton.vue'
import CoreIcon from '@/components/CoreIcon.vue'
import CoreCopyContentInput from '@/components/CoreCopyContentInput.vue'
import axios, { AxiosResponse } from 'axios'
import { Getter } from 'vuex-class'
import { StoreGetters, FormInterface } from '@/store'
import createPlatform from '@/api/providers/create-platform'
import checkIfPlatformReady from '@/api/providers/check-if-platform-ready'
import SuccessIcon from '../components/SuccessIcon.vue'
import { Routes } from '@/router'
import Spinner from '../components/Spinner.vue'

@Component({
    components: {
        CoreButton,
        CoreIcon,
        CoreCopyContentInput,
        SuccessIcon,
        Spinner,
    },
})
export default class ProgressPage extends Vue {
    @Getter(StoreGetters.FORM) public form!: FormInterface
    @Getter(StoreGetters.IS_FORM_VALID) public isFormValid!: boolean

    public completed = false
    public receiptID: any = ''
    public interval: any = null
    public authenticationToken = ''

    public get platformUrl(): string {
        return this.form.platformUrl + `/app/instant-login?token=${this.authenticationToken}`
    }

    public created() {
        if (!this.isFormValid) {
            this.$router.push({ name: Routes.PERSONAL_INFO })
        }
        this.createPlatform()
    }

    public createPlatform() {
        if (this.isFormValid) {
            this.form.platformName = this.form.platformName?.toLocaleLowerCase()
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this.form.utm_term = urlParams.get('utm_term') || '';
            this.form.utm_content = urlParams.get('utm_content') || '';
            this.form.utm_campaign = urlParams.get('utm_campaign') || '';
            this.form.utm_medium = urlParams.get('utm_medium') || '';
            this.form.utm_source = urlParams.get('utm_source') || '';
            const platformData = this.form;

            createPlatform(platformData)
                .then((resp: any) => resp.data)
                .then(({ receipt_id }) => {
                    this.receiptID = receipt_id
                    return receipt_id || ''
                })
                .then((id: any) => {
                    this.interval = setInterval(() => {
                        checkIfPlatformReady(id, platformData.region)
                            .then(resp => resp.data)
                            .then(data => {
                                if (data.errors || data.progress === 100) {
                                    clearInterval(this.interval)
                                    this.interval = null
                                    this.completed = true
                                }
                                if (data.progress === 100) {
                                    this.authenticationToken = data.data.loginToken
                                }
                            })
                    }, 3000)
                })
                .catch((error: { response: AxiosResponse<any> }) => {
                    this.$router.replace({
                        name: Routes.PLATFORM_SETTINGS,
                        query: {
                            error_code: error?.response?.data?.error_type ?? '',
                        },
                    })
                })
        }
    }

    public toggle() {
        this.completed = !this.completed
    }
}
